<span
	class="badge-indicator comment-notifications-indicator"
	[goTooltip]="'comment-notifications-unviewed-plural' | translate:{number: unviewedComments}"
	goTooltipPlacement="top">
	<i class="ficon-app-comment-outline"></i>
	<span class="unviewed-direct-value">
		{{unviewedComments}}
	</span>
</span>
